import { Injectable } from "@angular/core";
import { SocketService } from "./socket.service";
import { Helper } from "src/app/core/helpers/helper";
import { BehaviorSubject, Subscription } from "rxjs";

@Injectable({
  providedIn: "root"
})
export class ChatService {
  isSocketConnected: boolean = false;
  newMessageEventListenedForTicket: boolean = false;

  chatId: string = "";

  public chatList: Array<any> = [];

  chatSubscription!: Subscription;
  public chatSubject = new BehaviorSubject<any>(null);
  public chatMessages$ = this.chatSubject.asObservable();

  constructor(private socketService: SocketService, private helper: Helper) {}

  connectChatSocket(event: any, parameters: any): Promise<any> {
    return new Promise((resolve) => {
      this.isSocketConnected = true;

      this.socketService.sendAndListenEvent(event, parameters, async (data: any) => {
        this.getNewChatMessage();
        if (data.data.chatId) {
          this.chatId = data.data.chatId;
          this.chatList = [];
          this.chatList = await this.fetchChatMessages(data.data.chatId);
          this.chatSubject.next(this.chatList);
          resolve(this.chatList);
        } else {
          resolve([]);
        }
      });
    });
  }

  fetchChatMessages(chatId: string, uniqueId?: number): Promise<any> {
    return new Promise((resolve) => {
      const parameters: any = {
        event: this.helper.SocketEvents.CHAT_MESSAGES_FETCH,
        data: {
          chatId: chatId,
          uniqueId: uniqueId ?? -1
        }
      };

      this.socketService.sendAndListenEvent(this.helper.SocketEvents.CHAT_MESSAGES_FETCH, parameters, (data: any) => {
        if (data.data.messages) {
          resolve(data.data.messages);
        } else {
          resolve([]);
        }
      });
    });
  }

  getNewChatMessage(): void {
    this.chatSubscription = this.socketService.listener(this.helper.SocketEvents.CHAT_MESSAGE).subscribe((res: any) => {
      if (res.data) {
        this.chatList.push(res.data.message);
        this.chatSubject.next(this.chatList);
      }
    });
  }

  leaveSocketRoom(): void {
    const parameters: any = {
      data: {
        roomId: this.chatId
      }
    };
    this.socketService.emit(this.helper.SocketEvents.LEAVE_ROOM, parameters);
  }

  sendMessage(event: any, chatId: string, message: string, referenceId: string, chatType: string): void {
    const parameters: any = {
      event: event,
      data: {
        message: message
      }
    };

    if (chatId) parameters.data.chatId = chatId;
    if (referenceId) parameters.data.referenceId = referenceId;
    if (chatType) parameters.data.chatType = chatType;

    this.socketService.emit(event, parameters);
  }

  connectTicketChatSocket(event: any, parameters: any): Promise<any> {
    return new Promise((resolve) => {
      this.isSocketConnected = true;

      if (!this.newMessageEventListenedForTicket) {
        this.getNewChatMessageForTicket();
      }

      this.socketService.sendAndListenEvent(event, parameters, (data: any) => {
        resolve(data);
      });
    });
  }

  getNewChatMessageForTicket(): void {
    this.newMessageEventListenedForTicket = true;
    this.chatSubscription = this.socketService.listener(this.helper.SocketEvents.CHAT_MESSAGE).subscribe((res: any) => {
      if (res.data) {
        this.chatSubject.next([res.data]);
      }
    });
  }

  disConnectChatSockets(): void {
    this.chatId = "";
    this.chatList = [];
    this.chatSubject.next(this.chatList);
    this.leaveSocketRoom();
    this.socketService.disconnectSocket(this.helper.SocketEvents.JOIN_CHAT);
    this.socketService.disconnectSocket(this.helper.SocketEvents.CHAT_MESSAGES_FETCH);
    this.chatSubscription?.unsubscribe();
    this.isSocketConnected = false;
  }
}
